import React from 'react';
import { useBranding } from '../BrandingContext';

function WorkspaceLoader({ message = 'Loading workspace…' }) {
  const { isBranded, brand } = useBranding();
  return (
    <div
      className="app-loading"
      role="status"
      aria-live="polite"
      aria-atomic="true"
      aria-busy="true"
    >
      <img src={isBranded ? brand.logoUrl : '/logo_black.png'} alt={isBranded ? brand.name : 'EXREG'} className="app-loading__logo" style={isBranded ? { width: brand.logoAspect === 'wide' ? 176 : 72, ...(brand.logoAspect === 'wide' ? { backgroundColor: '#fff', padding: '7px 10px', borderRadius: 3 } : {}) } : undefined} />
      <span className="app-loading__spinner" aria-hidden="true" />
      <span>{message}</span>
    </div>
  );
}

export default WorkspaceLoader;
